import config from '../../../../config/config';
import { Configuration, CountriesApi } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const countriesApi = new CountriesApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
